import React from "react";

const WHATSAPP = "5511958325430";
const EMAIL    = "leamibasotnassotnas@gmail.com";

export default function EsqueciSenha() {
  return (
    <div style={{ minHeight:"100vh", background:"#0f172a", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <div style={{ background:"#131929", border:"1px solid #1e293b", borderRadius:16, padding:"40px 36px", width:"100%", maxWidth:440 }}>
        
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ fontSize:26, fontWeight:800, color:"#fff" }}>SAAS<span style={{ color:"#6366f1" }}>.GL</span></div>
          <div style={{ fontSize:13, color:"#64748b", marginTop:4 }}>Recuperacao de Senha</div>
        </div>

        <div style={{ background:"#1e293b", borderRadius:12, padding:"20px 24px", marginBottom:24, textAlign:"center" }}>
          <div style={{ fontSize:32, marginBottom:12 }}>🔐</div>
          <div style={{ fontSize:16, fontWeight:700, color:"#f1f5f9", marginBottom:8 }}>Esqueceu sua senha?</div>
          <div style={{ fontSize:14, color:"#94a3b8", lineHeight:1.7 }}>
            Para redefinir sua senha, entre em contato com o suporte da <strong style={{ color:"#6366f1" }}>SAAS.GL</strong>. Nossa equipe ira gerar uma senha temporaria para voce acessar o sistema imediatamente.
          </div>
        </div>

        <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:24 }}>
          <a href={"https://wa.me/" + WHATSAPP + "?text=" + encodeURIComponent("Ola! Esqueci minha senha do SAAS.GL e preciso de ajuda para recuperar o acesso.")}
            target="_blank" rel="noreferrer"
            style={{ display:"flex", alignItems:"center", gap:12, background:"#22c55e22", border:"1px solid #22c55e44", borderRadius:10, padding:"14px 20px", textDecoration:"none" }}>
            <span style={{ fontSize:22 }}>💬</span>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"#22c55e" }}>Chamar no WhatsApp</div>
              <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>Resposta rapida em horario comercial</div>
            </div>
          </a>

          <a href={"mailto:" + EMAIL + "?subject=" + encodeURIComponent("Recuperacao de Senha — SAAS.GL") + "&body=" + encodeURIComponent("Ola, esqueci minha senha e preciso de ajuda para recuperar o acesso ao sistema.")}
            style={{ display:"flex", alignItems:"center", gap:12, background:"#6366f122", border:"1px solid #6366f144", borderRadius:10, padding:"14px 20px", textDecoration:"none" }}>
            <span style={{ fontSize:22 }}>📧</span>
            <div>
              <div style={{ fontSize:14, fontWeight:700, color:"#6366f1" }}>Enviar Email</div>
              <div style={{ fontSize:12, color:"#64748b", marginTop:2 }}>{EMAIL}</div>
            </div>
          </a>
        </div>

        <div style={{ background:"#0f172a", borderRadius:8, padding:"12px 16px", marginBottom:20, fontSize:12, color:"#475569", lineHeight:1.6, textAlign:"center" }}>
          Apos o contato, nossa equipe ira gerar uma senha temporaria e enviar para voce por WhatsApp.
        </div>

        <div style={{ textAlign:"center" }}>
          <a href="/login" style={{ color:"#6366f1", fontSize:13, textDecoration:"none", fontWeight:600 }}>Voltar ao login</a>
        </div>
      </div>
    </div>
  );
}